import * as Models from "../Models";
import { action, observable } from "mobx";
import * as MobX from "mobx";
import { AccountStore } from "./Domain";
import { ApplicationFormStatusStore } from "./Domain";
import { DocumentTypeStore } from "./Domain";
import { SaveStore } from "./Domain";
import { SelectItemsStore } from "./Domain";
import { EditableCopy } from "Globals/Models";
import { EditableCopyRoute } from "Globals/Models";
import { RoleStore } from "./Domain/Admin";
import { Stores } from "./Stores";
import { UserStore } from "./Domain/Admin";
import { LenderTypeStore } from "./Domain";
import { LoanPurposeTypesStore } from "./Domain";
import { RelationshipTypeStore } from "./Domain";
import { HomeOwnerStatusStore } from "./Domain/HomeOwnerStatusStore";
import { PropertySizeStore } from "./Domain/PropertySizeStore";
import { PropertyTypeStore } from "./Domain/PropertyTypeStore";
import { AgeStore } from "./Domain/AgeStore";
import { EthnicityStore } from "./Domain/EthnicityStore";
import { SexualOrientationStore } from "./Domain/SexualOrientationStore";
import { ReligionStore } from "./Domain/ReligionStore";
import { DisabilityStore } from "./Domain/DisabilityStore";
import { SpecialRequirementsStore } from "./Domain/SpecialRequirementsStore";
import { ApplicantStatusStore } from "./Domain/ApplicantStatusStore";
import { RejectReasonStore } from "./Domain/RejectReasonStore";
import { NationalityStore } from "./Domain/NationalityStore";
import { LocalAuthorityStore } from "./Domain/LocalAuthorityStore";

export class DomainStores {
    @observable public openSnackBar = false;
    @observable public snackBarSeverity: "success" | "error" | "warning" | "info" = "success";
    @observable public openErrorDialog = false;
    @observable public errorDialogContent: string = "";
    @observable public snackBarContent: string = "";
    @observable public editableCopies = MobX.observable<EditableCopy>([]);
    @observable public editableCopyRoutes = MobX.observable<EditableCopyRoute>([]);
    public AccountStore = new AccountStore();
    public UserStore = new UserStore();
    public DocumentTypeStore = new DocumentTypeStore();
    public RoleStore = new RoleStore();
    public SelectItemsStore = new SelectItemsStore();
    public ApplicationFormStatusStore = new ApplicationFormStatusStore();
    public SaveStore = new SaveStore();
    public LenderTypeStore = new LenderTypeStore();
    public LoanPurposeTypesStore = new LoanPurposeTypesStore();
    public RelationshipTypeStore = new RelationshipTypeStore();
    public HomeOwnerStatusStore = new HomeOwnerStatusStore();
    public PropertySizeStore = new PropertySizeStore();
    public PropertyTypeStore = new PropertyTypeStore();
    public AgeStore = new AgeStore();
    public EthnicityStore = new EthnicityStore();
    public SexualOrientationStore = new SexualOrientationStore();
    public ReligionStore = new ReligionStore();
    public DisabilityStore = new DisabilityStore();
    public SpecialRequirementsStore = new SpecialRequirementsStore();
    public ApplicantStatusStore = new ApplicantStatusStore();
    public RejectReasonStore = new RejectReasonStore();
    public NationalityStore = new NationalityStore();
    public LocalAuthorityStore = new LocalAuthorityStore();

    constructor() {
        DomainStoresInstance = this;
    }

    public init(stores: Stores, initialState: Models.InitialState) {
        this.editableCopies.clear();
        this.editableCopyRoutes.clear();
        initialState.editableCopies.forEach((editableCopy) => {
            this.editableCopies.push(editableCopy);
        });
        initialState.editableCopyRoutes.forEach((editableCopyRoute) => {
            this.editableCopyRoutes.push(editableCopyRoute);
        });
        this.AccountStore.init(stores, initialState);
        this.ApplicationFormStatusStore.init(stores, initialState);
        this.DocumentTypeStore.init(stores, initialState);
        this.SaveStore.init(stores, initialState);
        this.LenderTypeStore.init(stores, initialState);
        this.LoanPurposeTypesStore.init(stores, initialState);
        this.RelationshipTypeStore.init(stores, initialState);
        this.HomeOwnerStatusStore.init(stores, initialState);
        this.PropertySizeStore.init(stores, initialState);
        this.PropertyTypeStore.init(stores, initialState);
        this.AgeStore.init(stores, initialState);
        this.EthnicityStore.init(stores, initialState);
        this.SexualOrientationStore.init(stores, initialState);
        this.ReligionStore.init(stores, initialState);
        this.DisabilityStore.init(stores, initialState);
        this.SpecialRequirementsStore.init(stores, initialState);
        this.ApplicantStatusStore.init(stores, initialState);
        this.RejectReasonStore.init(stores, initialState);
        this.NationalityStore.init(stores, initialState);
        this.LocalAuthorityStore.init(stores, initialState);
    }

    @action
    public OpenSnackBar(content: string, severity: "success" | "error" | "warning" | "info") {
        console.log("open snack");
        this.snackBarContent = content;
        this.snackBarSeverity = severity;
        this.openSnackBar = true;
    }

    @action
    public CloseSnackBar() {
        this.openSnackBar = false;
    }

    @action
    public ShowErrorDialog(content: string) {
        this.errorDialogContent = content;
        this.openErrorDialog = true;
    }
}
export let DomainStoresInstance = {} as DomainStores;
